import type { TableColumns } from '@ohpen/enso-ui';

import type { TranslationRow } from './interfaces';

/** The top level branches of the bundle, so the filter offers exactly what is there. */
export const AREA_LIST_NAME = 'translationAreas';

/** The layers a value can come from, named the way the reader is told them. */
export const TRANSLATION_SOURCE_LIST_NAME = 'translationSources';

export const translationColumns: TableColumns<TranslationRow> = [
  {
    title: 'config.columns.source',
    dataIndex: 'source',
    key: 'source',
    width: 160,
    options: {
      filter: 'select',
      listName: TRANSLATION_SOURCE_LIST_NAME,
      format: { type: 'valueList' },
      sorter: true,
      filterOptions: { allowedModes: ['anyMatches'] },
    },
  },
  {
    title: 'config.columns.area',
    dataIndex: 'area',
    key: 'area',
    width: 160,
    options: { filter: 'select', listName: AREA_LIST_NAME, sorter: true, filterOptions: { allowedModes: ['anyMatches'] } },
  },
  {
    title: 'config.columns.key',
    dataIndex: 'key',
    key: 'key',
    width: 420,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.english',
    dataIndex: 'en',
    key: 'en',
    width: 360,
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.dutch',
    dataIndex: 'nl',
    key: 'nl',
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
];
